import React, { Component } from "react";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import { BaseComponent } from "BaseComponent";
import { showError, showSuccess } from "ReduxErrorBar";
import { Row, Col, Modal } from "react-bootstrap";
import Button from "react-bootstrap-button-loader";
import _ from "lodash";
import { COMMON_FAIL_MESSAGE } from "Constants";
import LocaleStrings from "Languages";
import MasterLanguage from "LanguageList";
import {
  openLanguageCsvImportModal,
  updateEventLanguage,
  fetchEventLanguages,
} from "SettingActions";
import Dropzone from "react-dropzone";
import AppIcons from "AppIcons";
import defaulteng from "../../../../../../common/english-json";

class LanguageAdd extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      validated: false,
      fileData: [],
      fileUrl: "",
    };
  }

  close() {
    this.setState({
      fileUrl: "",
    });
    this.props.openLanguageCsvImportModal(false);
  }

  downloadSample = (type) => {
    let XLSX = require("xlsx");
    let sample = [];

    for (const key in defaulteng) {
      let obj = {};
      obj["Key"] = key;
      obj["Text"] = defaulteng[key];
      sample.push(obj);
    }
    // console.log("sample updated", sample);

    /* Create a new empty workbook, then add the worksheet */
    let wb = XLSX.utils.book_new();
    // console.log("wb", wb);

    /* Create a worksheet */
    var ws = XLSX.utils.json_to_sheet(sample);
    var sheetName = "sample";

    XLSX.utils.book_append_sheet(wb, ws, sheetName);

    /* Generate xlsx files */
    if (type === "csv") {
      XLSX.writeFile(wb, "default_english.csv");
    } else {
      XLSX.writeFile(wb, "default_english.xlsx");
    }
  };

  processCSV = (data) => {
    var modifiedArr = [];
    this.setState({ processingData: true });
    let result = _.drop(data, 1);
    if (result.length > 0) {
      //console.log("result", result);
      result.map((langval, index) => {
        var langkey =
          langval[0] && langval[0] != "" ? langval[0].toString().trim() : "";
        var langval =
          langval[1] && langval[1] != "" ? langval[1].toString().trim() : "";
        let jsonObj = {};
        if (langkey && langval != "") {
          jsonObj.key = langkey;
          jsonObj.value = langval;
        } else if (langkey && langval == "") {
          jsonObj.key = langkey;
        }

        modifiedArr.push(jsonObj);
      });
      // console.log("modifiedArr", modifiedArr);

      this.setState({
        fileData: modifiedArr,
      });
    }
  };

  onDrop = (files) => {
    let file = files[0];
    //console.log("file", file);
    this.setState({
      files,
      fileUrl: file.path,
    });
    //console.log("file", file);
    var Papa = require("papaparse/papaparse.min.js");
    if (file && file.type === "text/csv") {
      Papa.parse(file, {
        skipEmptyLines: true,
        complete: function (results, file) {
          //console.log("results", results);
          if (results.errors.length === 0) this.processCSV(results.data);
          else {
            this.setState({
              errorMessage: LocaleStrings.user_import_validation1,
            });
          }
        }.bind(this),
        error: function (error, reason) {
          //console.log("error");
          this.setState({
            errorMessage: LocaleStrings.user_import_validation1,
          });
        },
      });
    } else {
    }
  };

  onSubmitForm = (data) => {
    this.setState({ loading: true });
    let newdata = {};
    if (this.state.fileData && this.state.fileData.length > 0) {
      let jsonObj = {};
      _.map(this.state.fileData, (user, id) => {
        jsonObj[`${user.key}`] = user.value ? user.value : "";
      });
      newdata.languagejson = JSON.stringify(jsonObj);
    }
    let langId = parseInt(this.props.langId);
    newdata.id = langId;

    this.props.updateEventLanguage(this.props.session, newdata, (response) => {
      if (response.success === 0) {
        this.props.showError(COMMON_FAIL_MESSAGE);
      } else {
        this.props.fetchEventLanguages(this.props.session, (feedback) => {
          if (
            feedback.success === 1 &&
            feedback.data &&
            feedback.data.length > 0
          ) {
            var checkValue = _.filter(feedback.data, function (opt) {
              return opt.id == langId;
            });

            if (checkValue.length > 0) {
              this.props.reloadParent(checkValue);
              this.props.showSuccess(LocaleStrings.language_added_message);
              this.setState({ loading: false });
              this.close();
            } else {
            }
          }
        });
      }
    });
  };

  render() {
    var {
      handleSubmit,
      invalid,
      pristine,
      submitting,
      deviceSize,
      languageCsvImportModalReducer,
      langId,
    } = this.props;

    return (
      <div>
        <Modal
          className="modal-container"
          show={
            this.props.languageCsvImportModalReducer === true ? true : false
          }
          onHide={this.close}
          animation={true}
          keyboard={false}
          backdrop="static"
          dialogClassName="modal-md"
        >
          <Modal.Header>
            <div className="import-modal-title">
              {LocaleStrings.language_import_text}
            </div>
            <button
              type="button"
              className="i-custom-cross-popup pull-right"
              onClick={() => this.close()}
            >
              <img
                className="i-custom-small"
                src="../../style/images/custom-icons/cross-black.png"
              />
            </button>
          </Modal.Header>
          <Modal.Body>
            <form onSubmit={handleSubmit(this.onSubmitForm)}>
              <div style={{ fontSize: 14, fontWeight: 500 }}>
                {LocaleStrings.language_download_text}
              </div>
              <div>{LocaleStrings.language_tooltip_text}</div>
              <div className="pt-10">
                <div
                  className="importdropbox d-flex"
                  style={{
                    height: 40,
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <a
                    className="users-link"
                    onClick={() => this.downloadSample("csv")}
                  >
                    <span className="font-icomoon i-custom-ms">
                      {AppIcons.downloadicon}
                    </span>{" "}
                    <span className="import-option-button">
                      {LocaleStrings.language_download_text}
                    </span>
                  </a>
                </div>
              </div>
              <div className="pt-20">
                {this.state.fileUrl == "" ? (
                  <Dropzone
                    onDrop={this.onDrop}
                    multiple={false}
                    accept="text/csv"
                  >
                    {({ getRootProps, getInputProps }) => (
                      <div
                        className="importdropbox custom-align-center"
                        style={{
                          height: 150,
                        }}
                        {...getRootProps()}
                      >
                        <div>
                          <div>
                            <input {...getInputProps()} />
                            <span className="font-icomoon i-custom-ms">
                              {AppIcons.uploadericon}
                            </span>
                          </div>

                          <div>{LocaleStrings.language_upload_text}</div>
                        </div>
                      </div>
                    )}
                  </Dropzone>
                ) : (
                  <div
                    className="importdropbox custom-align-center"
                    style={{
                      height: 150,
                    }}
                  >
                    <div>{this.state.fileUrl}</div>
                  </div>
                )}
              </div>

              <div className="pt-20 text-right">
                <Button
                  className="btn-custom-blue"
                  loading={this.state.loading}
                  // disabled={pristine || invalid || submitting}
                  type="submit"
                >
                  {LocaleStrings.button_save}
                </Button>
              </div>
            </form>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="btn btn-custom-white"
              onClick={(e) => this.close()}
            >
              {LocaleStrings.button_cancel}
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

function validate(values) {
  var errors = {};

  //   if (!values.languagekey) {
  //     errors.languagekey =
  //       LocaleStrings.language_setting_add_new_form_language_error;
  //   }

  return errors;
}

function mapStateToProps(state) {
  return {
    session: state.session,
    user: state.user,
    deviceSize: state.deviceSize,
    languageCsvImportModalReducer: state.languageCsvImportModalReducer,
  };
}

export default connect(mapStateToProps, {
  showError,
  showSuccess,
  openLanguageCsvImportModal,
  updateEventLanguage,
  fetchEventLanguages,
})(
  reduxForm({
    form: "LanguageCSVForm",
    validate,
    /*asyncValidate,
        asyncBlurFields:['oldpwd'],*/
    enableReinitialize: true,
  })(LanguageAdd)
);
